/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".featuredPhoto[_ngcontent-%COMP%]{width:100%;height:100%;min-width:60px;max-width:300px;min-height:100px;max-height:250px;position:relative;visibility:initial;-o-object-fit:cover;object-fit:cover;border-radius:20px;display:block;margin:auto}@media(max-width:767px){#boxBody[_ngcontent-%COMP%]{display:none}}\n/*# sourceMappingURL=featured.component.css.map*/"];
export { styles as styles };
